export const setLoginFlagOnLocalStorage = (isLoggedIn : string) : void => {
  localStorage.setItem('isLoggedIn', isLoggedIn)
}
